import type { ConstsConfig } from '../declare'

const consts: ConstsConfig[] = [
  // ListSearch 配置加载完成时
  {
    name: 'LIST_SEARCH_CONFIG_LOADED',
    value: 'onListSearchConfigLoaded'
  },
  // 列表表单配置加载完成时
  {
    name: 'LIST_PAGE_CONFIG_LOADED',
    value: 'onListPageConfigLoaded'
  },
  // 编辑表单配置加载完成时
  {
    name: 'EDIT_PAGE_CONFIG_LOADED',
    value: 'onEditPageConfigLoaded'
  },
  // 编辑表单控件加载完成时
  {
    name: 'EDIT_PAGE_CONTROL_LOADED',
    value: 'onEditPageControlLoaded'
  },
  // 编辑表单表单数据记载完成时
  {
    name: 'EDIT_PAGE_FORM_LOADED',
    value: 'onEditPageFormLoaded'
  },
  // 编辑表单表单数据变更时
  {
    name: 'EDIT_PAGE_FORM_CHANGE',
    value: 'onEditPageFormChange'
  },
]

export default consts